import lockup from '@rumbo/marca/activos/lockup-mppt.png'

/**
 * Lockup oficial del Ministerio del Poder Popular para el Transporte.
 * Manual de Marca RBV: restricción #12 (tamaño mínimo 3 cm / 300 px de
 * ancho), #2 (no deformar: `object-fit: contain`, sin `stretch`), #5 (nunca
 * animado — Framer Motion no debe envolver este componente) y #3.2 (área de
 * seguridad 2X, donde X ≈ 22 % del alto del lockup).
 *
 * El ancho mínimo de 300 px no cabe en un teléfono de 360 px con márgenes;
 * en pantallas angostas se usa el tamaño reducido de la maqueta 8.6 del
 * manual (backoffice/formulario), documentado en docs/PLAN.md §3 y pendiente
 * de validación por el equipo de comunicación central (D-018).
 */
const ALTO_ANCHO = 161 / 657

export function LockupMPPT({ ancho = 200, className = '' }: { ancho?: number; className?: string }) {
  const alto = ancho * ALTO_ANCHO
  const margen = 2 * alto * 0.22
  return (
    <div
      className={className}
      style={{ width: ancho + margen * 2, height: alto + margen * 2, padding: margen, boxSizing: 'content-box' }}
    >
      <img
        src={lockup}
        alt="República Bolivariana de Venezuela — Ministerio del Poder Popular para el Transporte"
        width={ancho}
        height={alto}
        style={{ width: ancho, height: alto, objectFit: 'contain' }}
        draggable={false}
      />
    </div>
  )
}
